var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"font-title-2 underlined primary--text mt-16 mb-2"},[_vm._v(_vm._s(_vm.chapter.title))]),_vm._l((_vm.chapter.contents),function(content,index){return [_c('content-type',{key:'content_' + index,attrs:{"content":content}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }